import React from "react";
import "./techStack.css";
import {
  Html,
  CSS,
  Javascript,
  Git,
  Github,
  Vscode,
  ReactImg,
  Prisma,
  Typescript,
  Shadcn,
  Twilo,
  AppWrite,
} from "../../Portfolio Asset/exportAsset";
import { motion } from "framer-motion";

const TechStack = () => {
  return (
    <motion.div
      className="app__techstack"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.8,
        delay: 0.5,
        ease: [0, 0.71, 0.2, 1.01],
      }}
    >
      <h1 className="h1__text2">My Tech Stack</h1>
      <p className="p__text"> Technologies I’ve been working with recently</p>

      <div className="tech-icons">
        <div className="tech-icons-top">
          <img src={Html} alt="html icon" />
          <img src={CSS} alt="css icon" />
          <img src={Javascript} alt="js icon" />
          <img src={ReactImg} alt="react icon" />
        </div>

        <div className="tech-icons-bottom">
          <img src={Git} alt="git icon" />
          <img src={Github} alt="github icon" />
          <img src={Vscode} alt="vs icon" />
          <img src={Prisma} alt="prisma icon" />
        </div>

        <div className="tech-icons-top">
          <img src={Typescript} alt="Typescript icon" />
          <img src={Twilo} alt="twilo icon" />
          <img src={AppWrite} alt="appwrite icon" />
          <img src={Shadcn} alt="shadcn icon" />
        </div>
      </div>
    </motion.div>
  );
};

export default TechStack;
